import React, { FC, useEffect, useState } from 'react'
import { MoreFieldMappingItem, MoreMapping_Item_On_Get } from 'src/interfaces/Template.interface'
import TemplateListItemcopy from './TemplateListItemcopy'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { useAppDispatch } from 'src/redux/storeHooks'
import { deleteMoreMappingAsync, getMoreMappingAsync } from 'src/redux/actions/templateAndPricingActions'
import { toast } from 'react-toastify'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import AddNewMoreMappingTemplateModal from './AddNewMoreMappingTemplateModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatTimeZone } from 'src/utils/TimeZoneDateFormat'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {getApiErrorMessage, isApiPayloadSuccess, useDebounce} from 'src/marketConnect/helpers'

type LocationField = {
  input_type: string;
  name: string;
  href: string | null;
  display_name: string;
  is_required: boolean;
};

type MoreMappingItemPropType={
    item:MoreFieldMappingItem
    selectedPlatform:any,
    handleChange:any,
    searchdata:any
    allowDataInsertion?: boolean
    insertionPayload?: LocationField[]|[],
    currentActivePlatform: number | undefined
}
const MoreMappingItem : FC <MoreMappingItemPropType>= ({item,selectedPlatform,handleChange,searchdata,allowDataInsertion, insertionPayload, currentActivePlatform}) => {
    const [getMoreMappingData, setGetMoreMappingData] = useState<MoreMapping_Item_On_Get[] | []>([])
    const [getShowMoreMappingData, setGetShowMoreMappingData] = useState(false)
    const [showMoreMappingTemplateModal, setShowMoreMappingTemplateModal] = useState<boolean>(false)
    const [updatingMoreMappingData, setUpdatingMoreMappingData] = useState<MoreMapping_Item_On_Get | null>(
        null
      )
    const [selectedTemplateDataForDelete, setSelectedTemplateDataForDelete] = useState<null|any>()
    const [showAlertModalMoreMapping, setShowAlertModalMoreMapping] = useState<boolean>(false)
    const [showMoreMappingTemplateTable, setshowMoreMappingTemplateTable] = useState(false)
    const [selectedMappingItem, setSelectedMappingItem] = useState<MoreFieldMappingItem | null>(null)
    const [moreMappingsPagination, setMoreMappingsPagination] = useState({
        page: 1,
        limit: 5,
        count: 0,
        previous: null,
        next: null,
      })

    const dispatch = useAppDispatch()
    const isRequired = item?.isRequired;

    const getDeleteErrorMessage = (response: any) =>
      getApiErrorMessage(response, 'Unable to delete field mapping rule.')


      const getMoreMappingDataAsync = (page = 1,searchinput) => {
        setshowMoreMappingTemplateTable(true)
        setGetShowMoreMappingData(true)
        console.log('selectedMappingItem..............=id        ', selectedMappingItem?.id)
        const fieldId = item.id
        if (fieldId) {
        //    alert(1)
          dispatch(
            getMoreMappingAsync({

              platform_id: selectedPlatform.id,
              field_id: fieldId,
              paginationdata: {page: page, limit: 5, search: searchinput},
            })
          ).then((response) => {
            setGetMoreMappingData(response.payload.results)
            // setGetMoreMappingData(response.payload.results)
            setMoreMappingsPagination((pre) => ({
              ...pre,
              page: page,
              count: response.payload.count,
              previous: response.payload.previous,
              next: response.payload.next,
            }))
            setGetShowMoreMappingData(false)
          })
        }
      }
const debouncedSearch = useDebounce(searchdata[item.display_name], 500)

useEffect(() => {
  if(selectedPlatform?.id === currentActivePlatform){
  // if (selectedMappingItem) {
    getMoreMappingDataAsync(1, debouncedSearch)
  }
  // }
}, [debouncedSearch])
  return (
    <div> 
         <div className='accordion p-0 pt-2 p-sm-2' id='moreMappingAccordion'>
    <div className='accordion-item shadow'>
      <h2 className='accordion-header' id='moreMappingHeading'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target={'#moreMappingCollapse' + item?.id}
          aria-expanded='false'
          aria-controls={'moreMappingCollapse' + item?.id}
          onClick={() => {
            setSelectedMappingItem(item)
            getMoreMappingDataAsync(1,"")

            setshowMoreMappingTemplateTable(true)
            
          }}
            >
              <span className={isRequired ? 'required-spell' : ''}> {item.display_name} Field Mapping Rule</span>
            </button>
          </h2>
      <div
        id={'moreMappingCollapse' + item?.id}
        className='accordion-collapse collapse '
        aria-labelledby='moreMappingHeading'
        data-bs-parent='#moreMappingAccordion'
      >
        <div className='accordion-body'>
          <div>
              <div className="row">
                  <div className='col-sm-6 col-12 align-self-center '>
                      <p className='fw-bold '>
                      {' '}
                      Add {item.display_name} Field Mapping
                      </p>{' '}
                          <div className="col-6">
                                        <input
                                          className='form-control mr-sm-2 input-sm '
                                          name={item.display_name}
                                          type='search'
                                          placeholder='Search By Name'
                                          aria-label='Search'
                                          onChange={handleChange}
                                          onKeyDown={(ev) => {
                                            if (ev.key == 'Enter') {

                                            getMoreMappingDataAsync(1,searchdata[item.display_name])
                                            }
                                          }}
                                          value={searchdata[item.display_name]}
                                        />
                          
                                        </div>
                  </div>
                  <div className='col-12 col-sm-6 d-flex justify-content-end pe-0 mb-3'>
                      <button
                      className='btn btn-primary btn-sm align-self-end w-25'
                      onClick={() => {
                          setUpdatingMoreMappingData(null)
                          setShowMoreMappingTemplateModal(true)
                      }}
                      >
                      + Add new
                      </button>
                  </div>
              </div>

            {showMoreMappingTemplateTable ? (
              <div>
                {getShowMoreMappingData ? (
                  <div className='d-flex align-items-center justify-content-center'>
                    <h1>
                      <Spinner animation='border' variant='primary' />
                    </h1>
                  </div>
                ) : (
                  <>
                  
                      <div>
                          <div className='card-body w-100 py-3'>
                            {/* begin::Table container */}
                            <div className='table-responsive '>
                              {/* begin::Table */}
                              <table className='table table-striped table-hover table-sm   gs-0 gy-4'>
                                {/* begin::Table head */}
                                <thead>
                                  <tr className='fw-bold text-muted  border-bottom border-bottom-2'>
                                    <th className='min-w-150px ps-4 '>Rule Name</th>
                                    {getMoreMappingData && <th className='min-w-150px ps-4 '>
                                      <div className='d-flex gap-3'>Created At 
                                        <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                        >
                                          <span style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                          </span>
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      </th>
                                    }
                                    {getMoreMappingData && <th className='min-w-150px ps-4 '>
                                      <div className='d-flex gap-3'>Updated At
                                        <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                        >
                                          <span style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                          </span>
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      </th>}
                                    <th className='min-w-100px ps-4 '>Actions</th>
                                  </tr>
                                </thead>
                                {/* end::Table head */}
                                {/* begin::Table body */}
                                <tbody>
                                  {getMoreMappingData?.length
                                    ? getMoreMappingData.map((templateData) => (
                                        <>
                                          <TemplateListItemcopy
                                            key={templateData.id}
                                            name={templateData.name}
                                            created_at={templateData?.created_at}
                                            updated_at={templateData?.updated_at}
                                            onUpdate={() => {
                                              setShowMoreMappingTemplateModal(true)
                                              setUpdatingMoreMappingData(
                                                templateData
                                              )
                                            }}
                                            onDelete={() => {
                                              setSelectedTemplateDataForDelete(templateData)
                                              setShowAlertModalMoreMapping(true)
                                              // setGetShowMoreMappingData(true)
                                             
                                            }}
                                          />
                                        </>
                                      ))
                                    : null}
                                </tbody>
                                {/* end::Table body */}
                              </table>
                              {/* end::Table */}
                            </div>
                            {/* end::Table container */}
                          </div>
                       
                          <div className='d-flex flex-column'>
                            <div className='border-bottom my-2 border-2'></div>
                            <div className='d-flex flex-row justify-content-center mt-2'>
                              <div className=' m-3'>
                                <strong>
                                  Total {moreMappingsPagination.count} Records{' '}
                                </strong>
                              </div>
                              <Button
                                className='m-2'
                                onClick={() => {
                                  setMoreMappingsPagination((pre) => {
                                    return {
                                      ...pre,
                                      page: moreMappingsPagination.page - 1,
                                    }
                                  })
                                  getMoreMappingDataAsync(
                                    moreMappingsPagination.page - 1
                                 ,"" )
                                }}
                                disabled={moreMappingsPagination.previous == null}
                              >
                                -
                              </Button>
                              <Button
                                className='m-2'
                                // onClick={() => {
                                //   handlePaginationCategory(paginationCategoryData.page + 1)
                                //   onSendPaginationCategory(paginationCategoryData)
                                // }}
                                // disabled={next == null}
                                onClick={() => {
                                  setMoreMappingsPagination((pre) => {
                                    return {
                                      ...pre,
                                      page: moreMappingsPagination.page + 1,
                                    }
                                  })
                                  getMoreMappingDataAsync(
                                    moreMappingsPagination.page + 1
                                 ,"" )
                                }}
                                disabled={moreMappingsPagination.next == null}
                              >
                                +
                              </Button>
                            </div>
                          </div>
                      </div>
                 
                  </>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  </div>

  {showMoreMappingTemplateModal && selectedMappingItem && (
              <AddNewMoreMappingTemplateModal
                isVisible={showMoreMappingTemplateModal}
                item={selectedMappingItem}
                selectedSecondaryPlatform={selectedPlatform}
                closeModal={() => setShowMoreMappingTemplateModal(false)}
                moreMappingData={updatingMoreMappingData}
                getLatestMoreMappingDataList={() => getMoreMappingDataAsync(1,"")}
                allowDataInsertion={allowDataInsertion}
                insertionPayload={item?.insertion_payload}
              />
            )}

  <CommonAlertModal
           key={'more mappping'}
           title={` do you want to continue?`}
           subtitle='Press "Ok" for continue'
          //  successBtnTitle={ loggingIn ? 'Logging in...' : 'Confirm'}
          //  successDisabled={loggingIn}
           isVisible={showAlertModalMoreMapping}
           onSuccess={()=>{
          
            dispatch(
              deleteMoreMappingAsync({
                platforn_field_template_id:
                  selectedTemplateDataForDelete.id,
              })
            )
              .then((response) => {
                if (!isApiPayloadSuccess(response)) {
                  toast.error(getDeleteErrorMessage(response))
                  return
                }
                setGetShowMoreMappingData(false)
                getMoreMappingDataAsync(1,"")
                toast.success('Deleted Successfully')
              })
              .catch((error) => {
                toast.error(error?.message || 'Unable to delete field mapping rule.')
                setGetShowMoreMappingData(false)
              })
            setShowAlertModalMoreMapping(false)
           }}
           onCancel={()=>{
         
            setSelectedTemplateDataForDelete(null)
            setShowAlertModalMoreMapping(false)
           }}
           isTermsVisible={false}
          />

  
  
  </div>

  )
}

export default MoreMappingItem
